import React from 'react'
import PropTypes from 'prop-types'
import {Checkbox} from 'antd'

class AdvertisingProduct extends React.Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
    productAvailability: PropTypes.object,
    bundleProduct: PropTypes.object,
    onChange: PropTypes.func,
  }

  get variants() {
    return this.props.productAvailability.advertisingTypes
  }

  get standaloneVariants() {
    return this.variants.filter(v => v.standalone)
  }

  get additionalVariants() {
    return this.variants.filter(v => !v.standalone)
  }

  toggleVariant(variant) {
    let variants = [...this.props.product.advertisingVariants]

    const variantObj = this.variants.find(v => v.type === variant)

    // Remove other standalones if we add a standalone
    if (variantObj && variantObj.standalone) {
      const otherStandalones = this.standaloneVariants
        .map(v => v.type)
        .filter(v => v !== variant)

      variants = variants.filter(v => {
        return !otherStandalones.some(other => v.includes(other))
      })
    }

    // Add variant if it doesnt exist. Remove it if it exists
    if (variants.indexOf(variant) > -1) {
      variants = variants.filter(v => v !== variant)
    } else {
      variants.push(variant)
    }

    return this.props.onChange({advertisingVariants: variants})
  }

  renderVariantWithOptions(variant) {
    const isChecked = this.props.product.advertisingVariants.includes(variant.type)

    return (
      <div
        key={variant.type}
        style={{marginBottom: 15}}
      >
        <Checkbox
          checked={isChecked}
          onChange={() => this.toggleVariant(variant.type)}
        >
          {variant.name}
          <div>{variant.description}</div>
        </Checkbox>
        <div style={{paddingLeft: 38}}>
          {Object.entries(variant.extraProductOptions).map(([key, value]) =>
            <Checkbox
              key={`${variant.type}-${key}`}
              disabled={!isChecked}
              checked={this.props.product.advertisingVariants.includes(`${key}_${variant.type}`)}
              onChange={() => this.toggleVariant(`${key}_${variant.type}`)}
            >
              {value}
            </Checkbox>
          )}
        </div>
      </div>
    )
  }

  render() {
    if (this.props.bundleProduct) {
      return null
    }

    return (
      <div style={this.props.style}>
        <div style={{
          borderBottom: '1px solid #d8d8d8',
          marginBottom: 15,
        }}>
          {this.standaloneVariants.map(variant =>
            this.renderVariantWithOptions(variant)
          )}
        </div>

        <div>
          <p>Tilleggsvalg</p>
          {this.additionalVariants.map(variant =>
            this.renderVariantWithOptions(variant)
          )}
        </div>
      </div>
    )
  }
}

export default AdvertisingProduct
